import React from "react";

import { Box, IconButton, Modal, Typography } from "@mui/material";

import { SolidButton } from "components/buttons/SolidButton";
import { OutlineButton } from "components/buttons/OutlineButton";

import { ReactComponent as CloseIcon } from "assets/images/icons/btn_close.svg";

const EndSessionModal = ({ open, loading = false, onClose, onConfirm }) => {
  const handleClose = () => {
    if (loading) return;

    onClose?.();
  };

  const handleConfirm = () => {
    if (loading) return;

    onConfirm?.();
  };

  return (
    <Modal
      open={Boolean(open)}
      onClose={handleClose}
      aria-labelledby="end-session-title"
      aria-describedby="end-session-description"
      slotProps={{
        backdrop: {
          sx: {
            bgcolor: "rgba(15, 23, 42, 0.45)",
          },
        },
      }}
    >
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: 506,
          maxWidth: "calc(100% - 32px)",
          bgcolor: "#FFFFFF",
          borderRadius: "12px",
          overflow: "hidden",
          outline: "none",
          boxShadow: "0 24px 64px rgba(16, 24, 40, 0.22)",
        }}
      >
        {/* Header */}
        <Box
          sx={{
            minHeight: 62,
            px: 2,
            py: 1.5,
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            borderBottom: "1px solid #D9DEE8",
          }}
        >
          <Typography
            id="end-session-title"
            sx={{
              color: "#172B68",
              fontSize: 18,
              fontWeight: 700,
              lineHeight: 1.4,
            }}
          >
            End session?
          </Typography>

          <IconButton
            onClick={handleClose}
            disabled={loading}
            size="small"
            aria-label="Close"
            sx={{
              color: "#98A2B3",

              "&:hover": {
                bgcolor: "#F2F4F7",
              },
            }}
          >
            <CloseIcon />
          </IconButton>
        </Box>

        {/* Content */}
        <Box
          id="end-session-description"
          sx={{
            px: 2,
            py: 2.25,
          }}
        >
          <Typography
            sx={{
              color: "#667085",
              fontSize: 14,
              lineHeight: 1.6,
            }}
          >
            You will leave this customer environment. The support token will
            remain active and delegated to you, so you can enter again later.
          </Typography>
        </Box>

        {/* Footer */}
        <Box
          sx={{
            px: 2,
            py: 2,
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            gap: 2,
            borderTop: "1px solid #D9DEE8",
            bgcolor: "#FBFCFF",
          }}
        >
          <OutlineButton
            width="80px"
            height="32px"
            onClick={handleClose}
            disabled={loading}
          >
            Cancel
          </OutlineButton>
          <SolidButton
            onClick={handleConfirm}
            disabled={loading}
            width="120px"
            height="32px"
          >
            {" "}
            {loading ? "Ending..." : "End session"}
          </SolidButton>
        </Box>
      </Box>
    </Modal>
  );
};

export default EndSessionModal;
